import axios from 'axios';
import API_URL from '../config';

const api = axios.create({
  baseURL: API_URL,
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Authentification
export const login = async (username, password) => {
  const response = await api.post('/login', { username, password });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response.data;
};

export const checkTokenValidity = async () => {
  try {
    await api.get('/check-token');
    return true;
  } catch (error) {
    return false;
  }
};

// Sessions
export const getSessions = async () => {
  const response = await api.get('/sessions');
  return response.data;
};

export const getSession = async (id) => {
  const response = await api.get(`/sessions/${id}`);
  return response.data;
};

export const createSession = async (sessionData) => {
  const response = await api.post('/sessions', sessionData);
  return response.data;
};

export const updateSession = async (id, sessionData) => {
  const response = await api.put(`/sessions/${id}`, sessionData);
  return response.data;
};

export const deleteSession = async (id) => {
  const response = await api.delete(`/sessions/${id}`);
  return response.data;
};

// Activités
export const getActivities = async () => {
  const response = await api.get('/activities');
  return response.data;
};

export const createActivity = async (activityData) => {
  const response = await api.post('/activities', activityData);
  return response.data;
};

export const deleteActivity = async (id) => {
  const response = await api.delete(`/activities/${id}`);
  return response.data;
};

// Niveaux
export const getLevels = async () => {
  const response = await api.get('/levels');
  return response.data;
};

export const createLevel = async (levelData) => {
  const response = await api.post('/levels', levelData);
  return response.data;
};

export const deleteLevel = async (id) => {
  const response = await api.delete(`/levels/${id}`);
  return response.data;
};

// Fiches de palanquée
export const getFicheDates = async (sessionId) => {
  const response = await api.get(`/sessions/${sessionId}/fiches`);
  return response.data;
};

export const getFiches = async (sessionId, date) => {
  const response = await api.get(`/sessions/${sessionId}/fiches/${date}`);
  return response.data;
};

export const createFiche = async (sessionId, date, ficheData) => {
  const response = await api.post(`/sessions/${sessionId}/fiches/${date}`, ficheData);
  return response.data;
};

export const updateFiche = async (sessionId, date, ficheId, ficheData) => {
  const response = await api.put(`/sessions/${sessionId}/fiches/${date}/${ficheId}`, ficheData);
  return response.data;
};

export const deleteFiche = async (sessionId, date, ficheId) => {
  const response = await api.delete(`/sessions/${sessionId}/fiches/${date}/${ficheId}`);
  return response.data;
};

export default api;
